<template>
    <v-dialog v-model="active" persistent max-width="290">
        <v-card>
            <v-card-title class="headline">
                {{ title }}
            </v-card-title>
            <v-card-text>{{ body }}</v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" text @click="clickCancel">
                    {{ cancelButtonText }}
                </v-btn>
                <v-btn color="green darken-1" text @click="clickConfirm">
                    {{ confirmButtonText }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    name: 'NavConfirmationDialog',
    props: {
        title: {
            type: String,
            required: false,
            default: 'Unsaved changed',
        },
        body: {
            type: String,
            required: false,
            default: 'Are you sure you want to leave?',
        },
        confirmButtonText: {
            type: String,
            required: false,
            default: 'Leave',
        },
        cancelButtonText: {
            type: String,
            required: false,
            default: 'Stay',
        },
    },
    data() {
        return {
            active: false,
            resolve: null,
        }
    },
    methods: {
        pop() {
            this.active = true
            return new Promise(resolve => {
                this.resolve = resolve
            })
        },
        clickConfirm() {
            this.active = false
            this.resolve(true)
        },
        clickCancel() {
            this.active = false
            this.resolve(false)
        },
    },
}
</script>
